import { AsoEbiOrder, AsoEbiTransactionCostBearer } from "./aso.ebi";

export enum TransactionCtx {
  TxCtxBuyPackage = "buypackage",  
  TxCtxBuyAsoEbi = "buyasoebi",  
  TxCtxLovewallSubscription = "lovewallsubscription",
}

export enum TransactionInitiatorCtx {
  TxInitCtxAccount = "account",
}

export enum PaymentClient {
  PmtClientFlutterwave = "flutterwave",
  PmtClientPaystack = "paystack",
  PmtClientBudpay = "budpay",
}

export enum TransactionStatus {
  TxStatusSuccess = "success",
  TxStatusPending = "pending",
  TxStatusFailed = "failed",
}

export type Transaction<T = Record<string, any>> = {
  _id: string;
  transactionCtx: TransactionCtx;
  transactionCtxID: string;
  transactionInitiatorCtx: TransactionInitiatorCtx;
  transactionInitiatorCtxID: string;
  transactionReference: string;
  paymentClientReference: string;
  paymentClient: PaymentClient;
  transactionStatus: TransactionStatus;
  amount: number;
  fee: number;
  meta: T;
  createdAt: Date;
  updatedAt: Date;
};

export type AsoEbiTxnMeta = {
  fullName: string;
  email: string;
  phone: string;
  weddingID: string;
  accountID: string;
  deliveryAddress: string;
  asoEbiOrders: AsoEbiOrder[];
  asoEbiTransactionCostBearer: AsoEbiTransactionCostBearer;
};
